import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { demandsQueries } from "../graphql/queries";
import './UseCountProposals.css'

const UseCountProposals = (props) => {
  const [countProposals, setCountProposals] = useState(0);
  const { data: demandsData } = useQuery(demandsQueries.GET_DEMANDS, {
    variables: {
      search: '',
      sort: "code",
      page: 1,
      order: "desc",
      offset: 10,
      queryBy: 'status',
      isAuction: true
    }
  });

  useEffect(() => {
    const countProposalsLogic = () => {
      const total = demandsData?.listDemands?.pagination?.totalRecords
      if (typeof total === 'number') {
        setCountProposals(total)
      }
    };

    countProposalsLogic();
  }, [demandsData]);

  return (
    <div>
      {countProposals > 0 ? (
        <span className="countProposals">{countProposals}</span>
      ) : ''}
    </div>
  );
};

export default UseCountProposals;
